import { render, staticRenderFns } from "./HotelBestRate.vue?vue&type=template&id=8d97f562"
import script from "./HotelBestRate.vue?vue&type=script&lang=js"
export * from "./HotelBestRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports